// Status
export const CREATING = 'being_created'
export const AWAITING_VALIDATION = 'product_state_awaiting_validation'
export const VALIDATED = 'product_state_validated'
